"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORAGE_IDENTIFIER = exports.TRANSIENT_GROUP = exports.TRANSIENT_CID = exports.commonScopes = exports.transientScopes = exports.scopesOnlyForAuthedUsers = void 0;
exports.scopesOnlyForAuthedUsers = [
    'address',
    'booking.room.resv:folio',
    'booking.room.resv:update',
    'cart:remove',
    'directory.password:reset:guest',
    'directory.password:reset:self',
    'directory:read:guest',
    'directory:register:self',
    'directory:update:guest',
    'directory:update:self',
    'itinerary:read',
    'loyalty:comments:read',
    'loyalty:linkedprofiles:read',
    'loyalty:profile:create',
    'loyalty:profile:read',
    'loyalty:profile:update',
    'loyalty:promos:read',
    'loyalty:stopcodes:read',
    'loyalty:taxinfo:read',
    'offline_access',
    'phone',
    'profile:update',
    'rcs.rcs:all',
    'rcs.rcs:qrcode',
    'trip:read',
    'service:role',
    'restaurants.associate:read',
    'rooms.reservation.charges:override',
    'rooms.reservation:override',
];
exports.transientScopes = ['insecure'];
exports.commonScopes = [
    'booking.room.resv:search',
    'cart:checkout',
    'cart:create',
    'cart:delete',
    'cart:read',
    'cart:update',
    'email',
    'itinerary:create',
    'loyalty:balances:read',
    'myvegas.code:read',
    'openid',
    'order:read',
    'payments.storage:save',
    'payments.tokenization:tokenize',
    'profile',
    'profile:create',
    'profile:read',
    'restaurants.associate:read:guest',
    'restaurants.reservations:read',
    'restaurants.reservations:read:guest',
    'rooms.availability:read',
    'rooms.program:read',
    'rooms.reservation.charges:read',
    'rooms.reservation:create',
    'rooms.reservation:read',
    'rooms.reservation:update',
    'shows.availability:read',
    'shows.program:read',
    'shows.reservation.charges:read',
    'shows.reservation:create',
    'shows.reservation:read',
    'shows.seats:hold',
    'shows.seats:release',
    'trip:elevated',
];
exports.TRANSIENT_CID = 'mgm_app_anon_booking';
exports.TRANSIENT_GROUP = 'mgm_anon';
exports.STORAGE_IDENTIFIER = 'mgm_token';
